import { AllocationViewListSearchCriteria } from '../models';

export class AllocationViewListLoad {
  public static readonly type = '[AllocationViewList] Load';
  constructor(public payload: AllocationViewListSearchCriteria) {}
}

export class AllocationDriverViewListLoad {
  public static readonly type = '[AllocationDriverViewList] Driver Load';
  constructor(public payload: { uliId: number; endDate: number; startDate: number }) {}
}

export class AllocationViewListInitialState {
  public static readonly type = '[AllocationViewList] Set Initial State';
}
